import { encumbranceOptions } from 'modules/partners/constants/encumbranceOptions';
import { Encumbrance } from 'types';

export const getEncumbranceLabel = (encumbrance: Encumbrance) => {
  const selectedEncumbrance = encumbranceOptions.find(
    (option) => option.value === encumbrance?.type
  );

  return selectedEncumbrance
    ? `ShareEncumbranceOption_${selectedEncumbrance.label}`
    : '';
};
